export const collegeNames = [
  "GOVT FIRST GRADE COLLEGE VIJAYANAGARA",
  "ADHYAYANA P U COLLEGE",
  "AIRFORCE TECHNICAL COLLEGE",
  "AMBIKA INST OF EDUCATION SOCIETY",
  "ARUNODAYA ENGLISH HIGH SCHOOL",
  "ARUNODAYA PU COLLEGE",
  "ASHOK POLYTECNIC",
  "ATMAANANDA FOUNDATION",
  "B N R I P SCHOOL",
  "BBMP FIRST GRADE DEGREE COEELGE",
  "BBMP PRE UNIVERSITY COLLEGE OF GIRLS",
  "BBMP PU COLLEGE",
  "BBMP PU COLLEGE FOR GIRLS HIGH SCHOOL & PU COLLEGE",
  "BBMP PU COLLEGE(SHIVAJINAGARA)",
  "BISHOP COTTON ACADAMY OF PROFESSIONAL MANAGEMENT",
  "BRIGHT WAY PRE UNIVERSITY COLLEGE",
  "C V GURUKULA COLLEGE",
  "CHRIST DEEMED TO BE UNIVERSITY(YPR)",
  "COLUMBIA ASIA COLLEGE(BREIGADE)",
  "FALCON PU COLLEGE(PRASHASTHA FUTURE)",
  "FULLINFAWS COLLEGE",
  "G R PU COLLEGE(KANAKAPURA)",
  "G V EDUCATION TRUST",
  "GOOD WILL CHRISTIAN COLLEGE FOR WOMEN",
  "GOVERNEMENT FIRST GRADE COLLEGE T DASARAHALLI",
  "GOVT FIRST GRADE COLLEGE(JAYANAGAR)",
  "GOVT P U COLLEGE(KODIGEHALLI)",
  "GOVT WOMENS P U COLLEGE",
  "HILL SIDE PU COLLEGE",
  "HOLY ANGELS PUBLIC HIGH SCHOOL",
  "INDIAN ACADAMY DEGREE COLLEGE AUTONOMOUS",
  "INTERNATIONAL SCHOOL OF MAMENAGEMENT EXCELLENCE",
  "J S PRE UNIVERSITY COLLEGE",
  "JNANAGANGA INTERNATIONAL SCHOOL",
  "KLE LAW COLLEGE BENGAURU",
  "LOYALA COMPOSITE  P U COLLEGE",
  "LOYOLA DEGREE COLLEGE ",
  "M BASAVAIAH PU COLLGE OF SCIENCE & COMMERCE",
  "M S PU & DEGREE COLLEGE",
  "MAHARANI CLUSTER UNIVERSITY",
  "MAHARANI LAKSHMI AMMANNI COLLEGE FOR WOMEN ",
  "MAHARANI'S ARTS, COMMERCE & MANAGEMENT COLLEGE FOR WOMEN",
  "MAHARANI'S SCIENCE  COLLEGE FOR WOMEN",
  "MAHESH P U COLLEGE",
  "MANGALORE INDEPENDENT PU COLLEGE",
  "MARIYAPPA FIRST GRADE COLLEGE",
  "MAX MULLER PUBLIC SCHOOL .",
  "MCU SMT VHD CENTRAL INSTITUTE",
  "MKPM RV INSITUTE OF LEGAL STUDIES",
  "MLA PU COLLEGE FOR WOMEN",
  "N B C DEGREE COLLEGE",
  "NADGIR ENGLISH HIGH SCHOOL",
  "NATIONAL SCHOOL OF JOURNALISM HEBBAL",
  "NEW VANI VILAS GOVT P U COLLEGE",
  "NISARGA HIGH SCHOOL",
  "PARAGTHI PU COLLEGE(WHITE FIELD)",
  "PATEL GROUP OF  INSTITUTIONS",
  "PRAJWAL COMPOSITE PU COLLEGE",
  "R V ARTS & COMMERCE COLLEGE",
  "RAINBOW PUBLIC SCHOOL",
  "RAJJEV GANDHI PUBLIC HIGH SCHOOL",
  "RAMAN POLYTECNIC",
  "RASANA ENGLISH SCHOOL",
  "RASHTRIYA MILITARY SCHOOL",
  "REVA INDEPENDENT P U COLLEGE",
  "REVA INDEPENDENT PU COLLEGE",
  "RNVK P U COLLEGE",
  "S G P T A PRE UNIVERSITY COLLEGE",
  "S J R PU COLLEGE",
  "SADGURU EDUCATIONAL TRUST",
  "SAINIK PUBLIC SCHOOL",
  "SANMATHI VIDHYA SAMSTHE",
  "SHARADA COLLEGE OF NURSING",
  "SILICON CITY PU COLLEGE(KK CROSS)",
  "SILICON DEGREE COLLEGE",
  "SIR M VISHWESHWARAIH VIDHYANIKETHAN",
  "SREE VENKATESHWARA P U COLLEGE",
  "SRI ANUPAMA COLLEGE",
  "SRI ANUPAMA VIDYA MANDIR",
  "SRI NIDHI COMPUTERS & TUTORIALS",
  "SRI SAI COLLEGE FOR WOMEN",
  "SRI SAI P U COLLEGE",
  "SRI SIDDHAGANGA SWATANTRA PADAVI POORVA COLLEGE",
  "SRI V S KRISHNAIYYAR COPMPOSITE PU COLLEGE",
  "SRI VEENA ENGLISH PRIMARY & HIGH SCHOOL",
  "SRI VENKATESHWARA FIRST GRADE COLLEGE",
  "St ALOYSIS DEGREE COLLEGE ",
  "St ANNE'S DEGREE COLLEGE FOR WOMEN",
  "St CHARLES WOMEN'S PU COLLEGE",
  "St GEORGE COLLEGE OF MANAGEMENT STUDIES",
  "St JOSEPH'S COLLEGE OF COMMERCE",
  "St JOSEPH'S INSTITUE OF MANAGEMENT",
  "St JOSEPH'S UNIVERSITY",
  "St VINCENT PALLOTTI COLLEGE",
  "ST.PAULS COLLEGE ",
  "SUN RISE PUBLIC SCHOOL",
  "SUVARNA COLLEGE",
  "SUVARNA INSTITUTIONS PU COLLEGE",
  "TAPROOT COLLEGE(C V RAMAN NAGAR)",
  "TAPROOT COLLEGE(YELAHANKA)",
  "THE GOLDEN VALLY PUBLIC SCHOOL",
  "TRANSCEND DEGREE COLLEGE",
  "UDAYA COLLEGE",
  "V V N DEGREE COLLEGE",
  "VEDANTAH PU COLLEGE",
  "VIDHYAVRDHAKA SANGHA",
  "VISION PU COLLEGE (COMMERCE) ",
  "VIVEKANANDA COLLEGE OF LAW",
  "CHRIST ACADAMY INST OF ADVANCED STU",
  "DAYANAND SAGAR COLLEGE OF ARTS SCIE",
  "DAYANAND SAGAR M B A COLLGEE",
  "SESHADRIPURAM FIRST GRADE COLLEGE Yelahanka",
  "SESHADRIPURAM- Seshadripuram branch - Nagappa Street",
  "SESHADRIPURAM- Commerce and Management - Nagappa Street",
  "SILICON CITY COLLEGE",
  "St ALOYSIS DEGREE COLLEGE .",
  "BMS COLLEGE OF COMMERECE & MANAGEMENT",
  "G F S C-T DASARAHALLI",
  "K B C PU COLLEGE",
  "KRISTU JAYANTHI COLLEGE",
  "NMKRV WOMEN'S COLLEGE",
  "OXFORD COLEEGE OF ARTS",
  "OXFORD INDEPENDENT PU COLLEGE",
  "ROTARY BANGALORE VIDYALAYA",
  "SRI LAKSHMI RANGANATHA ENGLISH HIGH SCHOOL",
  "St CLARET COLLEGE(ATONOMOUS)",
  "St JOSEPH'S PRIMARY HIGH SCHOOL",
  "UNNATHI GURUKULA SCHOOL",
  "(A)SHESHADRIPURAM INST OF COM & MAN",
  "B COM(SHESHADRIPURAM)",
  "BMS COLLEGE FOR WOMEN",
  "BMS COLLEGE OF COMMERECE & MANA   ",
  "CHRIST(DEEMED TO BE UNIVERSITY)",
  "GOVT JOURNALISM COLLEGE",
  "IFIM COLLEGE .",
  "INTERNATIONAL SCHOOL OF MANAGEM",
  "JYOTHI INSTITUTE OF COMMERECE &",
  "JYOTI NIVAS COLLEGE",
  "R M S INST OF MANAGEMENT & SCIENCE",
  "RAJJEV GANDHI PUBLIC HIGH SCHOO",
  "RES POLYTECHNIC .",
  "RR College - (M B A 2ND SEM(R R INSTITUTE OF ADVA)",
  "SEA PRIMARY & HIGHER SECONDARY SCHO",
  "SHESHADRIPURAM ACADAMY OF BUISNESS",
  "SHESHADRIPURAM(B-COM)",
  "SHREE DAKSHA ACADEMY",
  "SIR M VISHWESHWARAIAH P U COLLEGE",
  "SIRI HIGH SCHOOL",
  "SREE VENKATESHWARA 2ND(YEAR DEG",
  "SREE VENKATESHWARA COLLEGE OF SCIEN",
  "St ANNE'S DEGREE COLLEGE FOR WO",
  "St ANNE'S P U COLLEGE",
  "St CHARLES WOMEN'S P U COLLEGE",
  "St JOSEPH'SINSTITUE OF MANAGEME",
  "VIKAS CENTRAL SCHOOL",
  "VISHWA VENKATESHWARA DEGREE COLLEGE",
  "BMSIT - Yelahanka",
  "Janna Jothi ",
  "KLE _IMSR_Hubli - MBA",
  "HASSAN PU COLLEGE",
  "Vidyavardhaka College of Engineering",
  "B N Bahadur Institute of Management Studies",
  "JSS Centre for Management Studies"
];
